import { render, staticRenderFns } from "./CopyrightAmendmentFormsEscalated.vue?vue&type=template&id=53c886c2&scoped=true&"
import script from "./CopyrightAmendmentFormsEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentFormsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentFormsEscalated.vue?vue&type=style&index=0&id=53c886c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c886c2",
  null
  
)

export default component.exports